import type { ReactNode } from 'react'
import type { ThemeTokens } from '../theme'

export interface StatCardProps {
  label: string
  value: ReactNode
  hint?: string
  tokens: ThemeTokens
  tone?: 'default' | 'danger'
}

/** Small at-a-glance metric card, shared across Budgets/Keys/Access pages. */
export function StatCard({ label, value, hint, tokens, tone = 'default' }: StatCardProps) {
  return (
    <div
      style={{
        background: tokens.surface,
        border: `1px solid ${tokens.border}`,
        borderRadius: '0.9rem',
        padding: '1rem 1.25rem',
        minWidth: '10rem',
        flex: '1 1 10rem',
      }}
    >
      <div
        style={{
          fontSize: '0.74rem',
          color: tokens.textSecondary,
          marginBottom: '0.35rem',
          textTransform: 'uppercase',
          letterSpacing: '0.03em',
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: '1.4rem', fontWeight: 700, color: tone === 'danger' ? tokens.danger : tokens.textPrimary }}>
        {value}
      </div>
      {hint ? <div style={{ fontSize: '0.76rem', color: tokens.textSecondary, marginTop: '0.3rem' }}>{hint}</div> : null}
    </div>
  )
}
